import { render, staticRenderFns } from "./route-card.vue?vue&type=template&id=b00ded4c"
import script from "./route-card.vue?vue&type=script&lang=js"
export * from "./route-card.vue?vue&type=script&lang=js"
import style0 from "./route-card.vue?vue&type=style&index=0&id=b00ded4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports